import React, { useEffect, useState } from "react";
// import { useFormik, Formik,Field } from "formik";
import { Formik, Field, FieldArray, Form, ErrorMessage } from "formik";
import TextErrors from "../share/TextErrors";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Label, Input } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { format } from "date-fns";
import { Loading } from "../share/loading";
import { FaSistrix } from "react-icons/fa";
import { NumberWithCommas } from "../share/NumberWithCommas";
import "../share/form.css";

export function AdminApproveBorrowFormComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  //console.log(user);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [remarkPromotionValue, setRemarkPromotionValue] = useState("");
  let borrowId = searchParams.get("req");
  const [dataRegister, setDataRegister] = useState([]);
  // const [data, setData] = useState([]);
  const [paymentdata, setpaymentData] = useState([]);
  // const paymentDataWithNoAmountApprove = paymentdata?.filter((item) => item.amountApprove === "" || item.amountApprove === null);
  const [foundAmount, setFoundAmount] = useState(false);
  //console.log("foundAmount", foundAmount)
  //console.log(paymentdata);


  useEffect(() => {
    setLoading(true)
    paymentdata.forEach((payment) => {
      //console.log(payment.amountApprove)
      if (payment.amountApprove !== null) {
        setFoundAmount(true)
      }
    })
  }, [paymentdata])
  useEffect(() => {
    getpaymentdata();
  }, []);

  useEffect(() => {

  })
  useEffect(() => {
    async function getDataRegister() {
      setLoading(true)
      let postData = new FormData();
      postData.append("borrowId", searchParams.get("req"))
      try {
        let res = await fetch("/api/Borrow/getBorrowByIdData", {
          method: "POST",
          body: postData,
        });
        let resJson = await res.json();
        setDataRegister(resJson.dataenum);
        //console.log("resJson =>", resJson)

      } catch (e) {
        //console.log("err => ", e)
      } finally {
        setLoading(false);
      }
    }
    getDataRegister();
  }, []);

  async function getpaymentdata() {
    setDataLoading(true)
    let postData = new FormData();
    postData.append("borrowId", borrowId);
    try {
      let res = await fetch("/api/Borrow/getpaymentdata", {
        method: "POST",
        body: postData,
      });
      const paymentdata = await res.json();
      //console.log(paymentdata.dataenum);
      setpaymentData(paymentdata.dataenum);
    } catch (e) {
      //console.log("err =>" + e);
    } finally {
      setDataLoading(false)
    }
  }

  const formPromotionInitialValues = {
    userApprove: user.fullName,
    remarkPromotion: remarkPromotionValue,
    borrowStatus: "14",
    borrowId: searchParams.get("req"),
    approvepayment: paymentdata.map((item) => ({
      amountApprove: item.amountApprove ?? "",
      paymentId: item.paymentId,
      amountLimit: item.amountLimit,
      approveCourseLawOccu: "",
      approveClassTime: ""
    })),

  };

  const validatePromotionSchema = Yup.object().shape({
    approvepayment: Yup.array().of(
      Yup.object().shape({
        // amountLimit:Yup.number(),
        amountApprove: Yup.number().typeError("ต้องเป็นตัวเลข").max(Yup.ref("amountLimit"), "จำนวนเงินต้องไม่มากกว่าจำนวนเงินที่ขอ").required("กรุณากรอกจำนวนเงิน"),
        approveCourseLawOccu: Yup.number().typeError("ต้องเป็นตัวเลข").required("กรุณากรอกจำนวนที่อนุมัติ"),
        approveClassTime: Yup.number().typeError("ต้องเป็นตัวเลข").required("กรุณากรอกจำนวนที่อนุมัติ")
      })
    )

  });

  const promotionSubmit = async (values, setFieldValue) => {

   // console.log(values);


    try {
      let res = await fetch("api/Borrow/approveOrRejectForSignContact", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(values),
      });
      //console.log("values", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/borrowing/`);
        });
      }
    } catch (e) {
      //console.log(e);
    }
  };



  return (
    <Container className="d-flex flex-column justify-content-center align-items-center">
      <p
        className="text-center py-2 text-white"
        style={{
          backgroundColor: "#0A66C2",
          width: "100%",
          maxWidth: "960px",
        }}
      >
        ข้อมูลคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
      </p>
      {/* รายละเอียดย่อย */}
      <div className="form-border">
        {!loading && !dataLoading ? (
          <>
            {dataRegister?.map((data, i) => (
              <div className="d-flex flex-column" key={i}>
                <div className="px-5 mt-5 d-flex justify-content-evenly">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="py-1 mx-1 type-register">
                      วันที่ขอกู้
                    </span>
                    <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1">
                      {data.createDate}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="py-1 mx-1 type-register">
                      ชื่อผู้ขอกู้ยืมเงิน
                    </span>
                    <span className="mx-2 input-color border border-1 rounded-pill px-5 py-1">
                      {data.employee}
                    </span>
                  </div>
                </div>
                <div className="text-center">
                  <button
                    className="btn-blue rounded-pill my-5"
                    onClick={() => {
                      navigate(
                        `/borrowing/admin/check/detail?id=${searchParams.get("req")}`
                      );
                    }}
                  >
                    ดูรายละเอียดคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพิ่มเติม
                    <FaSistrix className="mx-2 style-icon" />
                  </button>
                </div>
              </div>
            ))}
          </>
        ) : (
          <Loading />
        )}
      </div>
      <button onClick={() => {
        navigate(
          `/borrowing/`
        );
      }} className="btn-blue w-25"
      >
        ย้อนกลับ
      </button>
    </Container>
  );
}

